import React from "react";

import { useTranslation } from "react-i18next";

import ToggleOptionGroup from "../charts/ToggleOptionGroup";

import type { JSX } from "react";

import type { MapView } from "./dashboard.types";
import type { ToggleOption } from "../charts/ToggleOptionGroup";

interface MapViewToggleProps {
  ariaLabel: string;
  value: MapView;
  onChange: (value: MapView) => void;
}

function MapViewToggle({
  ariaLabel,
  value,
  onChange,
}: MapViewToggleProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  const optionList = [
    { value: "views", label: t("charts.series.views") },
    { value: "users", label: t("users") },
  ] satisfies ToggleOption<MapView>[];

  return (
    <ToggleOptionGroup
      ariaLabel={ariaLabel}
      onChange={onChange}
      optionList={optionList}
      value={value}
    />
  );
}

export default MapViewToggle;
